import styled from 'styled-components';

export const DashboardsDiv = styled.div`
    display: flex;
    border-bottom: 1px solid var(--gray-400);
    padding: 24px 0px;
    flex-direction: column;

    :first-child {
        padding: 0px;
    }
    
    :last-child {
        border-bottom: none;
    }
`

export const DashboardTitle = styled.span<{ hide?: boolean }>`
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: var(--gray-700);
    display: ${props => props.hide ? "none" : "unset"};
`

export const DashboardsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
` 

export const DashboardDivContainer = styled.div<{ background?: string }>`
    background: ${props => props.background ?? ''}; 
    border-radius: 4px;
    padding: 12px 16px;
    width: 99%;
`

export const DashboardsScroll = styled.div<{ isMobile?: boolean }>`
    padding-top: ${props => props.isMobile ? "0px" : "32px"};
    width: 100%;
    padding-bottom: 50px;
    overflow: ${props => props.isMobile ? "hidden" : "auto"};
    flex: 1;
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: ${({theme}) => theme['gray-0']};
    }
    
    &::-webkit-scrollbar {
        width: 6px;
        background-color: ${({theme}) => theme['gray-0']};
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: rgb(180,180,180);
    }
    
    scrollbar-color: rgb(180,180,180);
    scrollbar-width: thin;
`

export const ShowDiv = styled.div`
    color: var(--blue-500);
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;

    :hover {
        text-decoration: underline;
    }
`

export const TextHeader = styled.div`
    width: 100%;
    height: 36px;
    background-color: var(--gray-200);
    /* border-top: 1px solid var(--gray-300); */
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding-left: 10px;
    justify-content: space-between;
    margin-left: 2px;
`

export const Content = styled.div<{ sidebarOpen: boolean }>`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    overflow: auto;
    background-color: var(--gray-300);
    padding-left: ${props => props.sidebarOpen ? 0 : 32}px;

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: var(--gray-0);
    }

    &::-webkit-scrollbar {
        width: 6px;
        background-color: var(--gray-0);
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--gray-400);
    }

    scrollbar-color: var(--gray-400);
    scrollbar-width: thin;

    .rootClass {
        font-size: 14px
    }
`